





import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class TheButton extends Vue {
  @Prop({required: true})
  public text!: string;
}
